/* eslint-disable */
import { Platform } from 'react-native'
import platform from './platform'
import { API_URL } from '../config'

export default function(event, eventData = {}) {
  if (platform.isEmulator() || navigator.userAgent.match('Googlebot')) return
  
  fetch(`${API_URL}/track`, {
    method: 'POST',
    body: JSON.stringify({
      event,
      eventData,
      uniqueId: platform.getUniqueId(),
      platform: 'web',
    })
  })
}
